import React from "react";
import CustomButton from "../CustomButton";
import { MdClose } from "react-icons/md";


const CustomNotice = ({ message, onInvite, onClose, className }) => {
  return (
    <div
      className={`d-flex align-items-center justify-content-between p-3 m-4 rounded-4 border border-2 border-warning bg-warning bg-opacity-10 ${className} position-relative`}
    >
      <span style={{ fontSize: "1rem" }}>{message}</span>
      <div className="d-flex align-items-center px-4">
        <CustomButton
            className="m-0"
            onClick={onInvite}
        >
          Invite
        </CustomButton>
      </div>
      <MdClose 
        className="position-absolute top-0 end-0 m-2" 
        style={{ cursor: "pointer" }} 
        onClick={onClose} 
        size={20}
        color="gray"
      />

    </div>
  );
};

export default CustomNotice; 